import { render, staticRenderFns } from "./FeedbackRequirements.vue?vue&type=template&id=1787b074&scoped=true"
import script from "./FeedbackRequirements.vue?vue&type=script&lang=ts"
export * from "./FeedbackRequirements.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackRequirements.vue?vue&type=style&index=0&id=1787b074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787b074",
  null
  
)

export default component.exports